import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accounts from "../home/Component/totalVideoCreated";
import NftGraph from "../home/Component/totalNftsold";
import RevenueGraph from "../home/Component/revenueXdc";
import NewAccountsCreatedGraph from "../home/Component/newAccountscreated";
import Sellertable from "../home/Component/Sellertable";
import Line from "../home/Component/Graph";
import Accounts1 from "../home/Component/total_graph";
import Accounts2 from "../home/Component/revenue_graph";
// import Sellertable from "../home/Component/sellerTable";
import Buyertable from "../home/Component/Buyertable";
import Hashtags from "../home/Component/hasTag";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import Sidebar from "react-sidebar";
import SideBarComponent from "../../common/components/notificationBar";
import CssBaseline from "@material-ui/core/CssBaseline";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "auto",
    paddingLeft: 0,
    paddingRight: 0,
  },
  toolbar: {
    // paddingRight: 24,
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 30,
  },

  drawerPaper: {
    position: "absolute",
    whiteSpace: "nowrap",
    width: drawerWidth,
    background: "#001441",

    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflowX: "hidden",
    backgroundColor: "#F6F6F6",
  },
  container: {
    paddingTop: '74px',
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(13),
    paddingRight: theme.spacing(17),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginLeft: "0px",
      paddingTop: "64px",
      paddingRight: "25px",
      paddingBottom: "0",
    },
  },

  container1: {
    // paddingTop: theme.spacing(3),
    paddingTop: '35px',
    paddingBottom: theme.spacing(0),
    marginLeft: theme.spacing(13),
    paddingRight: theme.spacing(17),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginLeft: "0px",
      paddingTop: "64px",
      paddingRight: "25px",
      paddingBottom: "0",
    },
  },
  fixedHeight: {
    width: "auto",
    height: "200px",
    // backgroundColor: 'green'
  },
  link: {
    marginTop: theme.spacing(-6),
    marginBottom: theme.spacing(1),
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  iconbutton: {
    marginRight: theme.spacing(0),
  },

  container2: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridGap: theme.spacing(3),
    "@media (min-width: 768px) and (max-width: 1024px)": {
      display: "block",
      gridTemplateColumns: "repeat(12, 1fr)",
      gridGap: theme.spacing(3),
    },
  },
  hashtagContainer: {
    "@media (min-width: 768px) and (max-width: 1024px)": {
      marginTop: "24px",
    },
  },
  paper: {
    padding: theme.spacing(0),
    textAlign: "center",
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(0),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },

  Card: {
    maxHeight: 20,
  },
  revenueCount: {
    width:"100%",
    display:"flex",
    justifyContent:"space-between",
    padding:"7px 7px 0 5px"
  },
}));


function DashboardComponent(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  let revenueValue = Number(props?.revenueMetric?.totalRevenueCount[0]?.totalRevenue);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <div className={classes.root}>
      <CssBaseline />
    <main className={classes.content} id="main">
      <div className={classes.appBarSpacer} />
      <Container maxWidth="" className={classes.container}>
        <Typography className={classes.link} variant="h6" id="Dash">
          Dashboard
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Paper elevation={0} className={fixedHeightPaper}>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    {" "}
                    <Typography variant="h8" id="graph-text">
                      Total Videos Created
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    {" "}
                    <Typography
                      variant="h8"
                      style={{ color: "#5386F8" }}
                      id="graph-text1"
                    >
                      {props?.videoMetric?.totalVideosCount || ""}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              <Accounts />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Paper elevation={0} className={fixedHeightPaper}>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    <Typography variant="h8" id="graph-text">
                      New Accounts Created
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    <Typography
                      variant="h8"
                      style={{ color: "#FFA630" }}
                      id="graph-text1"
                    >
                      {props?.accountCreated?.totalAccountsCount}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              <NewAccountsCreatedGraph />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Paper elevation={0} className={fixedHeightPaper}>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    {" "}
                    <Typography variant="h8" id="graph-text">
                      Total NFTs Sold
                    </Typography>
                  </Paper>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={3}>
                  <Paper elevation={0}>
                    {" "}
                    <Typography
                      variant="h8"
                      style={{ color: "#C10000" }}
                      id="graph-text1"
                    >
                      {props?.nftSoldMetric?.totalNftCount || ""}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>

              <NftGraph nftSoldMetricData={props?.nftSoldMetric} />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Paper elevation={0} className={fixedHeightPaper}>
              <Grid container spacing={1} style={{width:"100%"}}>
                {/* <Grid item xs={3}> */}
                <div className={classes.revenueCount}>
                  {/* <Paper elevation={0}> */}
                    {" "}
                    <Typography variant="h8" id="graph-text">
                      Revenue (XDC)
                    </Typography>
                  {/* </Paper> */}
                {/* </Grid> */}
                {/* <Grid item xs={3}></Grid>
                <Grid item xs={3}></Grid> */}
                {/* <Grid item xs={3}> */}
                  {/* <Paper elevation={0}> */}
                    {" "}
                    <Typography
                      variant="h8"
                      style={{ color: "#00AE6D" }}
                      id="graph-text1"
                    >
                      {isNaN(revenueValue) ? "" : parseFloat(revenueValue).toFixed(2)}
                    </Typography>
                  {/* </Paper> */}
                {/* </Grid> */}
                </div>
              </Grid>

              <RevenueGraph />
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="" className={classes.container1}>
        <div className={classes.container2}>
          <div style={{ gridColumnEnd: "span 8" }}>
            <Paper elevation={0} className={classes.paper}>
              {" "}
              <Sellertable />{" "}
            </Paper>
            <Paper
              elevation={0}
              className={classes.paper}
              style={{ marginTop: '35px' }}
            >
              {" "}
              <Buyertable />{" "}
            </Paper>
          </div>
          <div style={{backgroundColor: 'white',gridColumnEnd: "span 4"}}
            className={classes.hashtagContainer}
          >
            <Paper  elevation={0} className={classes.paper}>
              {" "}
              <Hashtags />
            </Paper>
          </div>
        </div>
        {/*<SideBarComponent />*/}
      </Container>
    </main>
    </div>
  );
}

export default DashboardComponent;
